import 'utils/registrationAttribution';
import 'injectGoogleAds';
import 'setupApp';

import ReactDOM from 'react-dom';
import App from 'App';

import * as Sentry from '@sentry/react';
import chatttSDK from 'services/chattt';
import { init } from 'utils/tracker';
import 'lib/dayjs';

import { chatttSDKChannel } from 'services/chattt/sdk';
import { isInBrowser } from 'utils/is';

if (import.meta.env.PROD) {
  Sentry.init({
    environment: import.meta.env.VITE_ENV,
    dsn: chatttSDK ? import.meta.env.VITE_SENTRY_DNS_CLIENT : import.meta.env.VITE_SENTRY_DNS_WEB,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: ['Script error.', 'ResizeObserver loop limit exceeded'],
    // 偶然会遇到sentry post 400,如有需要可以关闭该项
    // sendClientReports: false,
    beforeSend(event) {
      // 检查 event 中是否有异常信息
      if (event.exception && event.exception.values) {
        for (const exception of event.exception.values) {
          if (exception.stacktrace && exception.stacktrace.frames) {
            for (const frame of exception.stacktrace.frames) {
              if (frame.filename) {
                const assetsIndex = frame.filename.indexOf('/assets');
                if (assetsIndex !== -1) {
                  // 截取 '/assets' 开始的部分
                  frame.filename = frame.filename.substring(assetsIndex);
                }
              }
            }
          }
        }
      }

      return event;
    },
  });
  if (chatttSDK?.app?.channel) {
    Sentry.setTag('channel', chatttSDKChannel);
  }
  if (chatttSDK?.app?.getVersion) {
    chatttSDK.app
      .getVersion()
      .then((chatttVersion) => {
        if (chatttVersion) {
          Sentry.setTag('chatpp', chatttVersion.replace(/^v{0,}/, 'v'));
          localStorage.setItem('chatppVer', chatttVersion);
        }
      })
      .catch((e) => {
        // do nothing
      });
  } else if (isInBrowser) {
    Sentry.setTag('chatpp', 'web');
  }
}
init({});

ReactDOM.render(<App />, document.getElementById('root'));

if (isInBrowser) {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevents the default mini-infobar or install dialog from appearing on mobile
    e.preventDefault();
    // Save the event because you'll need to trigger it later.
    window.__appDeferredPrompt = e;
    console.log('deferredPrompt');
    // Show your customized install prompt for your PWA
    // Your own UI doesn't have to be a single element, you
    // can have buttons in different locations, or wait to prompt
    // as part of a critical journey.
  });
}
